"use client";

import { createContext, useContext, useState, ReactNode } from "react";

type WizardContextType = {
    step: number;
    next: () => void;
    back: () => void;
    moveTo: (step: number) => void;
};

const WizardContext = createContext<WizardContextType | null>(null);

export const WizardProvider = ({ children }: { children: ReactNode }) => {
    const [step, setStep] = useState(1);

    const next = () => setStep((s) => s + 1);
    const back = () => setStep((s) => s - 1);
    const moveTo = (step: number) => setStep(step);

    return (
        <WizardContext.Provider value={{ step, next, back, moveTo }}>
            {children}
        </WizardContext.Provider>
    );
};

export const useWizardContext = () => {
    const context = useContext(WizardContext);
    if (!context) {
        throw new Error("useWizardContext must be used within a WizardProvider");
    }
    return context;
};
